// extracted by mini-css-extract-plugin
export var banner = "_3x-0";
export var icon = "_3x-1";
export var message = "_3x-2";